import { baseUrl } from '@fs/zion-config'
import { DocumentRecordSearch, DocumentBook, DocumentFolderCollection, ThingDevice } from '@fs/zion-icon'

import constants from './constants.json'

const URL_CONNECT_TO_TREE = `${baseUrl}/tree/guided/connect-to-tree`

export default {
  ...constants,
  COMPANY_STATS: [
    { Icon: DocumentRecordSearch, stat: '13.1B', description: 'Searchable names in Historical Records' },
    { Icon: DocumentBook, stat: '601K', description: 'Digital Books Online' },
    { Icon: DocumentFolderCollection, stat: '5.1B', description: 'Digital Images Published' },
    { Icon: ThingDevice, stat: '22.1M', description: 'Monthly Visits' },
  ],
  URL_LOGIN_CONNECT_TO_TREE: `/auth/familysearch/login?returnUrl=${encodeURIComponent(URL_CONNECT_TO_TREE)}`,
  URL_SIGNUP_CONNECT_TO_TREE: `/identity/signup/?returnUrl=${encodeURIComponent(URL_CONNECT_TO_TREE)}`,
}
